import React, { useState } from "react";
import Modal from "react-modal";
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { usePublicApiKeys } from "./public_api.hook";
import { CopyIcon } from "../../ui-kit/icons/copy";
import { Logo8returnsIcon } from "../../ui-kit/icons/logo_8returns";
import Header from "../../header/index";
import SubHeaderOld from "../../common/SubHeaderOld";

import { SuccessToast as successToast } from "../../common/SuccessToast";
import { ErrorToast as errorToast } from "../../common/ErrorToast";
import { TrashIcon2 } from "../../../ui-kit/icons/TrashIcon2";

const PublicApi = ({ current_user, api_settings }) => {
  const { apiKeys, t, wait, generate, update, destroy } = usePublicApiKeys({
    api_settings,
    current_user,
  });

  const [toDelete, setToDelete] = useState({});

  async function nameEdited(e, id, name) {
    const newValue = e.target.value;
    if (newValue == name) return;

    const { success, error } = await update(id, { name: newValue });
    if (success) {
      successToast({
        toastId: "updateApiKeySuccess",
        message: t.api_key_updated
      });
    } else {
      errorToast({
        toastId: "updateApiKeyError",
        message: error
      });
    }
  }

  function copyToClipboard(text) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
      successToast({ message: t.copied });
    }
  }

  let content;

  if (apiKeys.length) {
    content = apiKeys.map(({ id, name, api_key: key, password }) => {
      return (
        <div key={id} className="flex items-end my-4 gap-5">
          <div className="flex flex-col">
            <label className="font-medium text-xs leading-4 text-gray-725 mb-1">
              {t.api_key_name_8returns}
            </label>
            <input
              className="focus:outline-none bg-white box-border rounded-lg border py-9px pr-2 pl-4 font-medium text-sm leading-5 text-gray-875 focus:outline-none focus:border focus:border-blue-675 border-gray-325"
              defaultValue={name}
              onBlur={e => nameEdited(e, id, name)}
            />
          </div>
          <div className="flex flex-col">
            <label className="font-medium text-xs leading-4 text-gray-725 mb-1">
              {t.api_key_8returns}
            </label>
            <div className="flex items-center relative">
              <input
                className="w-full focus:outline-none bg-white box-border rounded-lg border py-9px pr-8 pl-4 border-gray-325 font-medium text-sm leading-5 text-gray-875 mr-4 focus:outline-none focus:border focus:border-blue-675 border-gray-325"
                readOnly
                value={key}
              />
              <CopyIcon onClick={() => copyToClipboard(key)} />
            </div>
          </div>
          <div className="flex flex-col">
            <label className="font-medium text-xs leading-4 text-gray-725 mb-1">
              {t.password_8returns}
            </label>
            <div className="flex items-center relative">
              <input
                className="w-full focus:outline-none bg-white box-border rounded-lg border py-9px pr-8 pl-4 border-gray-325 font-medium text-sm leading-5 text-gray-875 mr-4 focus:outline-none focus:border focus:border-blue-675 border-gray-325"
                readOnly
                type={password ? 'text' : 'password'}
                value={password || 'not available'}
              />
              { password && <CopyIcon onClick={() => copyToClipboard(password)} /> }
            </div>
          </div>
          <div className="flex flex-col pt-4">
            <button
              className={`rounded-lg border bg-red-525 py-9px px-4 font-semibold text-sm leading-5 text-white hover:bg-red-525 focus:outline-none focus:border focus:border-red-525 focus:shadow-btn_red ${
                wait ? "cursor-default" : ""
              }`}
              disabled={wait}
              onClick={() => setToDelete({ id, name })}
            >
              {t.delete}
            </button>
          </div>
        </div>
      );
    });
  } else {
    content = (
      <p className="font-normal text-sm leading-5 text-gray-625">
        {t.api_8returns_empty}
      </p>
    );
  }

  const closeModal = () => setToDelete({});

  return (
    <div className="font-inter">
      <ReactNotification className="left-0 right-0 m-auto" />
      <Modal
        isOpen={!!toDelete.id}
        onRequestClose={closeModal}
        style={{
          content: {
            maxWidth: "470px",
            maxHeight: "185px",
            margin: "auto",
            padding: "24px",
          },
        }}
      >
        <div>
          <div className="flex items-center mb-3">
            <TrashIcon2 />

            <p className="font-semibold text-base leading-6 text-gray-825 ml-3">
              {toDelete.name}: {t.delete_api_key}
            </p>
          </div>

          <p className="font-normal text-xs13 leading-4 text-gray-625 mb-5">
            {t.delete_api_key_sure}
          </p>

          <div className="flex justify-end">
            <button
              className="font-semibold text-sm leading-5 text-gray-875 py-2 px-4 border box-border rounded-lg border-gray-325 hover:border-gray-425 focus:outline-none focus:border-blue-625 focus:shadow-btn_blue focus:border-blue-625"
              onClick={closeModal}
            >
              {t.delete_api_key_cancel}
            </button>

            <button
              className="fnot-italic font-semibold text-sm leading-5 text-white bg-red-525 rounded-lg py-2 px-4 ml-3 focus:outline-none hover:bg-red-800 focus:bg-red-525 focus:shadow-btn_red"
              onClick={() => { destroy(toDelete.id); setToDelete({}) }}
            >
              {t.delete_api_key_yes}
            </button>
          </div>
        </div>
      </Modal>
      <Header
        current_user={current_user}
        text={"8returns API"}
        settings={t.settings}
        integrations={t.integrations}
      />
      <SubHeaderOld text={"8returns API"} />
      <div className="my-8 mx-8">
        <Logo8returnsIcon />
      </div>

      <div className="mx-8 mt-4">
        {content}
      </div>
      <div className="mx-8 mt-4">
        <h1 className="font-semibold text-base leading-6 text-gray-825 mt-8">
          {t.generate_api_key}
        </h1>
        <Generate t={t} wait={wait} submit={generate} />
      </div>
    </div>
  );
}

const Generate = ({ t, wait, submit }) => {
  const [name, setName] = useState('');
  const disabled = wait || !name;

  async function click() {
    const { success, error } = await submit({ name });
    if (success) {
      setName('');
      successToast({
        toastId: "generateApiKeySuccess",
        message: t.api_key_generated
      });
    } else {
      errorToast({
        toastId: "generateApiKeyError",
        message: error
      });
    }
  }

  return (
    <div className="flex items-end my-4 gap-5">
      <div className="flex flex-col">
        <label className="font-medium text-xs leading-4 text-gray-725 mb-1">
          {t.api_key_name_8returns}
        </label>
        <div className="flex items-center relative">
          <input
            className="focus:outline-none bg-white box-border rounded-lg border py-9px pr-2 pl-4 font-medium text-sm leading-5 text-gray-875 focus:outline-none focus:border focus:border-blue-675 border-gray-325"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </div>
      </div>
      <div className="flex flex-col pt-4">
        <button
          type="button"
          className={`rounded-lg border py-9px px-4 font-semibold text-sm leading-5 text-white focus:outline-none focus:border ${
            disabled ?
            "cursor-default bg-gray-600" :
            "bg-blue-675 hover:bg-blue-625 focus:border-blue-625 focus:shadow-btn_blue"
          }`}
          disabled={disabled}
          onClick={click}
        >
          {t.generate}
        </button>
      </div>
    </div>
  );
}

export default PublicApi;
